import script from "./ToolSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolSidebar.vue?vue&type=script&setup=true&lang=js"

import "./ToolSidebar.vue?vue&type=style&index=0&id=4277a9b0&scoped=true&lang=css"
import "./ToolSidebar.vue?vue&type=style&index=1&id=4277a9b0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4277a9b0"]])

export default __exports__